<template>
  <div class="schedule-planner--container">
    <div class="alert alert-sm alert-info text-center">
      Если в момент срабатывания планировщика окажется, что в каком-либо дне уже стоит расписание
      или вручную задан выходной день, 
      то правило к этим дням применено не будет
      <br><br>
      Вы можете поддерживать актуальное расписание вплоть <b>до 10 недель</b> вперед
    </div>
    <div v-if="this.staffList.length > 0" class="mrg-t-20">
      <div class="text-bold text-center fs-15 text-underline">Планировщик графика работы сотрудников</div>
      <div class="mrg-t-20">
        <schedule-planner-schedule
          :staffList="staffList"
        ></schedule-planner-schedule>
      </div>
      <div class="mrg-t-30">
        <div class="text-bold text-center fs-15 text-underline">Планировщик групповых записей</div>
        <div v-if="!existsGroupServices" class="mrg-t-20">
          <div class="text-danger text-center text-small">
            У вас пока что нет групповых услуг
          </div>
        </div>
        <div v-if="existsGroupServices" class="mrg-t-20">
          <schedule-planner-group
          :staffList="staffList"
          :servicesList="servicesList"
          ></schedule-planner-group>
        </div>
      </div>
    </div>
    <div v-if="this.staffList.length === 0 && request" class="mrg-t-20">
      <div class="alert alert-sm alert-danger">
        Пока что не создано ни одного сотрудника
      </div>
    </div>
  </div>
</template>

<script>
import SchedulePlannerSchedule from './SchedulePlannerSchedule.vue';
import SchedulePlannerGroup from './SchedulePlannerGroup.vue';
import staffRepository from "../../../repositories/staff";
import servicesRepository from "../../../repositories/services";

export default {
  name: "SchedulePlanner",
  components: {SchedulePlannerSchedule, SchedulePlannerGroup  },
  data() {
    return {
      request: false,
      staffList: [],
      servicesList: []
    };
  },
  props: {
    show: Boolean
  },
  watch: {
    show: function(val){
      if(val){
        // Запрашиваем список сотрудников и услуг
        this.getStaffList();
        this.getServicesList();
      }
    }
  },
  computed: {
    existsGroupServices(){
      let result = false;
      for(let key in this.servicesList){
        if(this.servicesList[key].services && this.servicesList[key].services.length > 0){
          for(let serv in this.servicesList[key].services){
            if(this.servicesList[key].services[serv].is_group == 1){
              result = true;
              break;
            }
            if(
              this.servicesList[key].services[serv].modification && 
              this.servicesList[key].services[serv].modification.length > 0
            ){
              for(let modif in this.servicesList[key].services[serv].modification){
                if(this.servicesList[key].services[serv].modification[modif].is_group == 1){
                  result = true;
                  break;
                }
              }
            }
          }
        }
      }
      return result;
    }
  },
  methods: {
    getStaffList(){
      staffRepository.getStaff().then(resp => {
        this.request = true;
        this.staffList = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    getServicesList(){
      servicesRepository.getServices().then(resp => {
        this.servicesList = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  },
  created() {
    
  },
  mounted() {
    
  }
};
</script>

<style scoped lang="less">

</style>
